import React from 'react';
import { Link } from 'react-router-dom';
import cImg from '../../images/prices/image-1.jpg';

const Newsletter = props => {
	const ClickHandler = () => {
		window.scrollTo(10, 0);
	};

	return (
		<section
			className="relative  bg-center bg-cover bg-no-repeat bg-fixed pt-[100px] pb-[95px] z-10 
            before:content-[''] before:bg-[rgba(21,26,48,0.9)] before:w-full before:h-full before:absolute before:left-0 before:-z-10 before:top-0"
			style={{ backgroundImage: `url(${cImg})` }}
		>
			<div className='wraper'>
				<div className='grid grid-cols-12 gap-3'>
					<div className='col-span-12 md:col-span-12 col:col-span-12'>
						<div className='text-center col:w-full mx-auto'>
							<h3 className='text-[36px] sm:text-[22px] font-medium mb-[40px] sm:mb-[30px] text-[#c0b596]'>
								Honoraires
							</h3>
							<p className='text-[#fff] pb-8'>
								Au sein de notre cabinet, la transparence est une valeur fondamentale en matière de
								frais et honoraires. Dès le premier rendez-vous, nous prenons le temps d'examiner avec
								vous les modalités de calcul de ces derniers, en tenant compte de la nature et de
								l'importance de votre affaire. Vous recevrez un document explicatif détaillé, à signer
								pour accord, garantissant une parfaite clarté et évitant tout malentendu.
							</p>
							<p className='text-[#fff] pb-8'>
								Que ce soit sur la base d’un taux horaire ou d’un forfait adapté à certaines situations,
								notre approche se veut à la fois juste et adaptée à chaque dossier. Nous sommes
								également attentifs aux démarches administratives associées, comme les frais de
								procédure ou les éventuels débours, toujours transparents et justifiables.
							</p>
							<p className='text-[#fff] pb-8'>
								Pour découvrir l'ensemble des modalités de notre tarification et obtenir des
								informations précises sur les options disponibles, rendez-vous sur notre page dédiée.
								Notre objectif est de répondre à toutes vos interrogations et de vous accompagner avec
								rigueur et confiance.
							</p>
							<Link
								onClick={ClickHandler}
								to='/honoraires'
								className='border-solid border-2 border-[#c0b596] cursor-pointer text-[16px] font-semibold text-white px-[38px] py-[10px]  capitalize inline-block mt-[6px] transition ease-in-out duration-300 hover:bg-[#d4c291]
                            col:mb-[5px] col:mt-[15px] col:text-[15px] col:px-[18px] col:py-[8px] mr-[20px]
                            '
							>
								Lire plus ...
							</Link>
							<Link
								onClick={ClickHandler}
								to='/contact'
								className='bg-[#c0b596] cursor-pointer text-[16px] font-semibold text-white px-[38px] py-[10px]  capitalize inline-block mt-[6px] transition ease-in-out duration-300 hover:bg-[#d4c291]
                            col:mb-[5px] col:mt-[15px] col:text-[15px] col:px-[18px] col:py-[8px] 
                            '
							>
								Contactez-nous
							</Link>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default Newsletter;
